import type * as Types from '../../../../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type PhotoWithSmartLayoutCropsFieldsFragment = {
  __typename?: 'PhotoWithSmartLayoutCrops';
  id: string;
  url: string;
  width: number;
  height: number;
  crops: Array<{
    __typename?: 'LayoutCropSlot';
    presentationLayout: string;
    variationType?: Types.DesignLayoutType | null;
    slotIndex?: number | null;
    cropInfo?: { __typename?: 'CropRect'; x: number; y: number; width: number; height: number } | null;
    mobileCropInfo?: { __typename?: 'CropRect'; x: number; y: number; width: number; height: number } | null;
    alignment?: { __typename?: 'WebsitePhotoAlignment'; alignX: Types.PhotoXPosition; alignY: Types.PhotoYPosition } | null;
  }>;
};

export type DesignRecommendationJobFieldsFragment = {
  __typename?: 'WebsiteStylistDesignRecommendationJob';
  id: string;
  status: Types.WebsiteStylistDesignRecommendationJobStatus;
  createdAt: string;
  updatedAt: string;
  startedAt?: string | null;
  completedAt?: string | null;
  result?: {
    __typename?: 'WebsiteDesignRecommendations';
    id: string;
    recommendations: Array<{
      __typename?: 'WebsiteDesignRecommendation';
      id: string;
      rank: number;
      title: string;
      previewUrl?: string | null;
      design: {
        __typename?: 'WebsiteStylistDesignRecommendationConfig';
        themeId: string;
        layoutId: string;
        variationType: Types.DesignLayoutType;
        fontPackName: string;
        useCustomTheme: boolean;
        useSuggestedThemeColor: boolean;
        brannanNavigation?: Types.BrannanNavigation | null;
        colorPalette: { __typename?: 'WebsiteColorPalette'; artBackground: string; artFont: string; pageBackground: string; pageFont: string; linkAndButton: string };
        headerLayout: { __typename?: 'WebsiteStylistHeaderLayoutSettings'; schemaURL: string; websiteLayout: Types.DesignLayoutType; dataJSON: any };
      };
      reasoning: { __typename?: 'WebsiteStylistReasoning'; summary: string };
    }>;
    inputPhotos: Array<{
      __typename?: 'PhotoWithSmartLayoutCrops';
      id: string;
      url: string;
      width: number;
      height: number;
      crops: Array<{
        __typename?: 'LayoutCropSlot';
        presentationLayout: string;
        variationType?: Types.DesignLayoutType | null;
        slotIndex?: number | null;
        cropInfo?: { __typename?: 'CropRect'; x: number; y: number; width: number; height: number } | null;
        mobileCropInfo?: { __typename?: 'CropRect'; x: number; y: number; width: number; height: number } | null;
        alignment?: { __typename?: 'WebsitePhotoAlignment'; alignX: Types.PhotoXPosition; alignY: Types.PhotoYPosition } | null;
      }>;
    }>;
    metadata: {
      __typename?: 'WebsiteStylistDesignRecommendationsMetadata';
      requestId: string;
      generatedAt: string;
      promptVersion: string;
      fallbackUsed: boolean;
      elapsedMs: number;
    };
  } | null;
  error?: { __typename?: 'WebsiteStylistDesignRecommendationJobError'; code: string; message: string } | null;
};

export type WebsiteStylistStartDesignRecommendationsMutationVariables = Types.Exact<{
  input: Types.WebsiteStylistStartDesignRecommendationsInput;
}>;

export type WebsiteStylistStartDesignRecommendationsMutation = {
  __typename?: 'Mutation';
  websiteStylistStartDesignRecommendations: {
    __typename?: 'WebsiteStylistDesignRecommendationJob';
    id: string;
    status: Types.WebsiteStylistDesignRecommendationJobStatus;
    createdAt: string;
    updatedAt: string;
    startedAt?: string | null;
    completedAt?: string | null;
    result?: {
      __typename?: 'WebsiteDesignRecommendations';
      id: string;
      recommendations: Array<{
        __typename?: 'WebsiteDesignRecommendation';
        id: string;
        rank: number;
        title: string;
        previewUrl?: string | null;
        design: {
          __typename?: 'WebsiteStylistDesignRecommendationConfig';
          themeId: string;
          layoutId: string;
          variationType: Types.DesignLayoutType;
          fontPackName: string;
          useCustomTheme: boolean;
          useSuggestedThemeColor: boolean;
          brannanNavigation?: Types.BrannanNavigation | null;
          colorPalette: { __typename?: 'WebsiteColorPalette'; artBackground: string; artFont: string; pageBackground: string; pageFont: string; linkAndButton: string };
          headerLayout: { __typename?: 'WebsiteStylistHeaderLayoutSettings'; schemaURL: string; websiteLayout: Types.DesignLayoutType; dataJSON: any };
        };
        reasoning: { __typename?: 'WebsiteStylistReasoning'; summary: string };
      }>;
      inputPhotos: Array<{
        __typename?: 'PhotoWithSmartLayoutCrops';
        id: string;
        url: string;
        width: number;
        height: number;
        crops: Array<{
          __typename?: 'LayoutCropSlot';
          presentationLayout: string;
          variationType?: Types.DesignLayoutType | null;
          slotIndex?: number | null;
          cropInfo?: { __typename?: 'CropRect'; x: number; y: number; width: number; height: number } | null;
          mobileCropInfo?: { __typename?: 'CropRect'; x: number; y: number; width: number; height: number } | null;
          alignment?: { __typename?: 'WebsitePhotoAlignment'; alignX: Types.PhotoXPosition; alignY: Types.PhotoYPosition } | null;
        }>;
      }>;
      metadata: {
        __typename?: 'WebsiteStylistDesignRecommendationsMetadata';
        requestId: string;
        generatedAt: string;
        promptVersion: string;
        fallbackUsed: boolean;
        elapsedMs: number;
      };
    } | null;
    error?: { __typename?: 'WebsiteStylistDesignRecommendationJobError'; code: string; message: string } | null;
  };
};

export type WebsiteStylistApplyDesignRecommendationMutationVariables = Types.Exact<{
  input: Types.WebsiteStylistApplyDesignRecommendationInput;
}>;

export type WebsiteStylistApplyDesignRecommendationMutation = {
  __typename?: 'Mutation';
  websiteStylistApplyDesignRecommendation: { __typename?: 'WebsiteStylistDesignRecommendationJob'; id: string; selectedDesignId?: string | null; selectedAt?: string | null };
};

export type WebsiteStylistDesignRecommendationJobQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;

export type WebsiteStylistDesignRecommendationJobQuery = {
  __typename?: 'Query';
  websiteStylistDesignRecommendationJob: {
    __typename?: 'WebsiteStylistDesignRecommendationJob';
    id: string;
    status: Types.WebsiteStylistDesignRecommendationJobStatus;
    createdAt: string;
    updatedAt: string;
    startedAt?: string | null;
    completedAt?: string | null;
    result?: {
      __typename?: 'WebsiteDesignRecommendations';
      id: string;
      recommendations: Array<{
        __typename?: 'WebsiteDesignRecommendation';
        id: string;
        rank: number;
        title: string;
        previewUrl?: string | null;
        design: {
          __typename?: 'WebsiteStylistDesignRecommendationConfig';
          themeId: string;
          layoutId: string;
          variationType: Types.DesignLayoutType;
          fontPackName: string;
          useCustomTheme: boolean;
          useSuggestedThemeColor: boolean;
          brannanNavigation?: Types.BrannanNavigation | null;
          colorPalette: { __typename?: 'WebsiteColorPalette'; artBackground: string; artFont: string; pageBackground: string; pageFont: string; linkAndButton: string };
          headerLayout: { __typename?: 'WebsiteStylistHeaderLayoutSettings'; schemaURL: string; websiteLayout: Types.DesignLayoutType; dataJSON: any };
        };
        reasoning: { __typename?: 'WebsiteStylistReasoning'; summary: string };
      }>;
      inputPhotos: Array<{
        __typename?: 'PhotoWithSmartLayoutCrops';
        id: string;
        url: string;
        width: number;
        height: number;
        crops: Array<{
          __typename?: 'LayoutCropSlot';
          presentationLayout: string;
          variationType?: Types.DesignLayoutType | null;
          slotIndex?: number | null;
          cropInfo?: { __typename?: 'CropRect'; x: number; y: number; width: number; height: number } | null;
          mobileCropInfo?: { __typename?: 'CropRect'; x: number; y: number; width: number; height: number } | null;
          alignment?: { __typename?: 'WebsitePhotoAlignment'; alignX: Types.PhotoXPosition; alignY: Types.PhotoYPosition } | null;
        }>;
      }>;
      metadata: {
        __typename?: 'WebsiteStylistDesignRecommendationsMetadata';
        requestId: string;
        generatedAt: string;
        promptVersion: string;
        fallbackUsed: boolean;
        elapsedMs: number;
      };
    } | null;
    error?: { __typename?: 'WebsiteStylistDesignRecommendationJobError'; code: string; message: string } | null;
  };
};

export type WebsiteStylistDerivePhotoCropsQueryVariables = Types.Exact<{
  input: Types.WebsiteStylistDerivePhotoCropsInput;
}>;

export type WebsiteStylistDerivePhotoCropsQuery = {
  __typename?: 'Query';
  websiteStylistDerivePhotoCrops: {
    __typename?: 'WebsiteStylistDerivedPhotoCrops';
    photos: Array<{
      __typename?: 'PhotoWithSmartLayoutCrops';
      id: string;
      url: string;
      width: number;
      height: number;
      crops: Array<{
        __typename?: 'LayoutCropSlot';
        presentationLayout: string;
        variationType?: Types.DesignLayoutType | null;
        slotIndex?: number | null;
        cropInfo?: { __typename?: 'CropRect'; x: number; y: number; width: number; height: number } | null;
        mobileCropInfo?: { __typename?: 'CropRect'; x: number; y: number; width: number; height: number } | null;
        alignment?: { __typename?: 'WebsitePhotoAlignment'; alignX: Types.PhotoXPosition; alignY: Types.PhotoYPosition } | null;
      }>;
    }>;
    metadata: { __typename?: 'WebsiteStylistDerivedPhotoCropsMetadata'; requestId: string; generatedAt: string; elapsedMs: number };
  };
};

export const PhotoWithSmartLayoutCropsFieldsFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoWithSmartLayoutCropsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhotoWithSmartLayoutCrops' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crops' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'presentationLayout' } },
                { kind: 'Field', name: { kind: 'Name', value: 'variationType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slotIndex' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cropInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mobileCropInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'alignment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'alignX' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'alignY' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const DesignRecommendationJobFieldsFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DesignRecommendationJobFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WebsiteStylistDesignRecommendationJob' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'result' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recommendations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'design' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'themeId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'layoutId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'variationType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fontPackName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'useCustomTheme' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'useSuggestedThemeColor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'brannanNavigation' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'colorPalette' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'artBackground' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'artFont' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pageBackground' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pageFont' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'linkAndButton' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'headerLayout' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'schemaURL' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'websiteLayout' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'dataJSON' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reasoning' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'summary' } }] },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'inputPhotos' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PhotoWithSmartLayoutCropsFields' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'requestId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'generatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'promptVersion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fallbackUsed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'elapsedMs' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'error' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoWithSmartLayoutCropsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhotoWithSmartLayoutCrops' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crops' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'presentationLayout' } },
                { kind: 'Field', name: { kind: 'Name', value: 'variationType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slotIndex' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cropInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mobileCropInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'alignment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'alignX' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'alignY' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const WebsiteStylistStartDesignRecommendationsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'WebsiteStylistStartDesignRecommendations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'WebsiteStylistStartDesignRecommendationsInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'websiteStylistStartDesignRecommendations' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DesignRecommendationJobFields' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoWithSmartLayoutCropsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhotoWithSmartLayoutCrops' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crops' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'presentationLayout' } },
                { kind: 'Field', name: { kind: 'Name', value: 'variationType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slotIndex' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cropInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mobileCropInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'alignment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'alignX' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'alignY' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DesignRecommendationJobFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WebsiteStylistDesignRecommendationJob' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'result' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recommendations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'design' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'themeId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'layoutId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'variationType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fontPackName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'useCustomTheme' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'useSuggestedThemeColor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'brannanNavigation' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'colorPalette' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'artBackground' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'artFont' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pageBackground' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pageFont' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'linkAndButton' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'headerLayout' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'schemaURL' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'websiteLayout' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'dataJSON' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reasoning' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'summary' } }] },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'inputPhotos' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PhotoWithSmartLayoutCropsFields' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'requestId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'generatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'promptVersion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fallbackUsed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'elapsedMs' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'error' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type WebsiteStylistStartDesignRecommendationsMutationFn = Apollo.MutationFunction<
  WebsiteStylistStartDesignRecommendationsMutation,
  WebsiteStylistStartDesignRecommendationsMutationVariables
>;

/**
 * __useWebsiteStylistStartDesignRecommendationsMutation__
 *
 * To run a mutation, you first call `useWebsiteStylistStartDesignRecommendationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebsiteStylistStartDesignRecommendationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [websiteStylistStartDesignRecommendationsMutation, { data, loading, error }] = useWebsiteStylistStartDesignRecommendationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWebsiteStylistStartDesignRecommendationsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<WebsiteStylistStartDesignRecommendationsMutation, WebsiteStylistStartDesignRecommendationsMutationVariables>,
) {
  return ApolloReactHooks.useMutation<WebsiteStylistStartDesignRecommendationsMutation, WebsiteStylistStartDesignRecommendationsMutationVariables>(
    WebsiteStylistStartDesignRecommendationsDocument,
    baseOptions,
  );
}
export type WebsiteStylistStartDesignRecommendationsMutationHookResult = ReturnType<typeof useWebsiteStylistStartDesignRecommendationsMutation>;
export type WebsiteStylistStartDesignRecommendationsMutationResult = Apollo.MutationResult<WebsiteStylistStartDesignRecommendationsMutation>;
export type WebsiteStylistStartDesignRecommendationsMutationOptions = Apollo.BaseMutationOptions<
  WebsiteStylistStartDesignRecommendationsMutation,
  WebsiteStylistStartDesignRecommendationsMutationVariables
>;
export const WebsiteStylistApplyDesignRecommendationDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'WebsiteStylistApplyDesignRecommendation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'WebsiteStylistApplyDesignRecommendationInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'websiteStylistApplyDesignRecommendation' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'selectedDesignId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'selectedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type WebsiteStylistApplyDesignRecommendationMutationFn = Apollo.MutationFunction<
  WebsiteStylistApplyDesignRecommendationMutation,
  WebsiteStylistApplyDesignRecommendationMutationVariables
>;

/**
 * __useWebsiteStylistApplyDesignRecommendationMutation__
 *
 * To run a mutation, you first call `useWebsiteStylistApplyDesignRecommendationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebsiteStylistApplyDesignRecommendationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [websiteStylistApplyDesignRecommendationMutation, { data, loading, error }] = useWebsiteStylistApplyDesignRecommendationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWebsiteStylistApplyDesignRecommendationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<WebsiteStylistApplyDesignRecommendationMutation, WebsiteStylistApplyDesignRecommendationMutationVariables>,
) {
  return ApolloReactHooks.useMutation<WebsiteStylistApplyDesignRecommendationMutation, WebsiteStylistApplyDesignRecommendationMutationVariables>(
    WebsiteStylistApplyDesignRecommendationDocument,
    baseOptions,
  );
}
export type WebsiteStylistApplyDesignRecommendationMutationHookResult = ReturnType<typeof useWebsiteStylistApplyDesignRecommendationMutation>;
export type WebsiteStylistApplyDesignRecommendationMutationResult = Apollo.MutationResult<WebsiteStylistApplyDesignRecommendationMutation>;
export type WebsiteStylistApplyDesignRecommendationMutationOptions = Apollo.BaseMutationOptions<
  WebsiteStylistApplyDesignRecommendationMutation,
  WebsiteStylistApplyDesignRecommendationMutationVariables
>;
export const WebsiteStylistDesignRecommendationJobDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WebsiteStylistDesignRecommendationJob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'websiteStylistDesignRecommendationJob' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DesignRecommendationJobFields' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoWithSmartLayoutCropsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhotoWithSmartLayoutCrops' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crops' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'presentationLayout' } },
                { kind: 'Field', name: { kind: 'Name', value: 'variationType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slotIndex' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cropInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mobileCropInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'alignment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'alignX' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'alignY' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DesignRecommendationJobFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WebsiteStylistDesignRecommendationJob' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'result' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recommendations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'design' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'themeId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'layoutId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'variationType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fontPackName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'useCustomTheme' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'useSuggestedThemeColor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'brannanNavigation' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'colorPalette' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'artBackground' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'artFont' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pageBackground' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pageFont' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'linkAndButton' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'headerLayout' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'schemaURL' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'websiteLayout' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'dataJSON' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reasoning' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'summary' } }] },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'inputPhotos' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PhotoWithSmartLayoutCropsFields' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'requestId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'generatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'promptVersion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fallbackUsed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'elapsedMs' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'error' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useWebsiteStylistDesignRecommendationJobQuery__
 *
 * To run a query within a React component, call `useWebsiteStylistDesignRecommendationJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteStylistDesignRecommendationJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteStylistDesignRecommendationJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWebsiteStylistDesignRecommendationJobQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<WebsiteStylistDesignRecommendationJobQuery, WebsiteStylistDesignRecommendationJobQueryVariables>,
) {
  return ApolloReactHooks.useQuery<WebsiteStylistDesignRecommendationJobQuery, WebsiteStylistDesignRecommendationJobQueryVariables>(
    WebsiteStylistDesignRecommendationJobDocument,
    baseOptions,
  );
}
export function useWebsiteStylistDesignRecommendationJobLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebsiteStylistDesignRecommendationJobQuery, WebsiteStylistDesignRecommendationJobQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<WebsiteStylistDesignRecommendationJobQuery, WebsiteStylistDesignRecommendationJobQueryVariables>(
    WebsiteStylistDesignRecommendationJobDocument,
    baseOptions,
  );
}
export type WebsiteStylistDesignRecommendationJobQueryHookResult = ReturnType<typeof useWebsiteStylistDesignRecommendationJobQuery>;
export type WebsiteStylistDesignRecommendationJobLazyQueryHookResult = ReturnType<typeof useWebsiteStylistDesignRecommendationJobLazyQuery>;
export type WebsiteStylistDesignRecommendationJobQueryResult = Apollo.QueryResult<WebsiteStylistDesignRecommendationJobQuery, WebsiteStylistDesignRecommendationJobQueryVariables>;
export const WebsiteStylistDerivePhotoCropsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WebsiteStylistDerivePhotoCrops' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'WebsiteStylistDerivePhotoCropsInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'websiteStylistDerivePhotoCrops' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photos' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PhotoWithSmartLayoutCropsFields' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'requestId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'generatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'elapsedMs' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoWithSmartLayoutCropsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhotoWithSmartLayoutCrops' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crops' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'presentationLayout' } },
                { kind: 'Field', name: { kind: 'Name', value: 'variationType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slotIndex' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cropInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mobileCropInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'alignment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'alignX' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'alignY' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useWebsiteStylistDerivePhotoCropsQuery__
 *
 * To run a query within a React component, call `useWebsiteStylistDerivePhotoCropsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteStylistDerivePhotoCropsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteStylistDerivePhotoCropsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWebsiteStylistDerivePhotoCropsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<WebsiteStylistDerivePhotoCropsQuery, WebsiteStylistDerivePhotoCropsQueryVariables>,
) {
  return ApolloReactHooks.useQuery<WebsiteStylistDerivePhotoCropsQuery, WebsiteStylistDerivePhotoCropsQueryVariables>(WebsiteStylistDerivePhotoCropsDocument, baseOptions);
}
export function useWebsiteStylistDerivePhotoCropsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebsiteStylistDerivePhotoCropsQuery, WebsiteStylistDerivePhotoCropsQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<WebsiteStylistDerivePhotoCropsQuery, WebsiteStylistDerivePhotoCropsQueryVariables>(WebsiteStylistDerivePhotoCropsDocument, baseOptions);
}
export type WebsiteStylistDerivePhotoCropsQueryHookResult = ReturnType<typeof useWebsiteStylistDerivePhotoCropsQuery>;
export type WebsiteStylistDerivePhotoCropsLazyQueryHookResult = ReturnType<typeof useWebsiteStylistDerivePhotoCropsLazyQuery>;
export type WebsiteStylistDerivePhotoCropsQueryResult = Apollo.QueryResult<WebsiteStylistDerivePhotoCropsQuery, WebsiteStylistDerivePhotoCropsQueryVariables>;
